export default __webpack_public_path__ + "static/media/tohum-nasil-uretilir.f68c4804.jpg";